import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { CreateManufacturerMutation, Manufacturer } from '#/graphql/types';
import { createManufacturer } from '#/graphql/mutations';
import { createMutationFields } from '../utils/mutationDataFields';
import { inUseStatuses } from '../utils/constants';

const q = gql(createManufacturer);

const useManufacturerCreate = () => {
  const [mutation, result] = useMutation<CreateManufacturerMutation>(q);
  const createManufacturer = useCallback(
    async (manufacturer: Manufacturer) => {
      const response = await mutation({
        variables: {
          data: {
            ...pick(manufacturer, createMutationFields),
            inUseStatus: inUseStatuses.newlyCreated.key,
          },
        },
      });
      return get(response, 'data.createManufacturer', undefined);
    },
    [mutation],
  );

  return { createManufacturer, result };
};

export default useManufacturerCreate;
